import React from 'react';
import './style.scss';
import Select, {
  ActionMeta, components, PropsValue, SingleValue,
} from 'react-select';
import { SearchSmall } from '../../../atoms/icons';
import useReactSelect from './customSelectStyle';

interface Props {
    id: string
    value?: PropsValue<any>
    // eslint-disable-next-line no-unused-vars
    onChange? : ((newValue: SingleValue<any>, actionMeta: ActionMeta<any>) => void) | undefined
    placeholder: string
    disabled?: boolean | undefined
    onBlur? : React.FocusEventHandler<HTMLInputElement> | undefined
    className?: string;
    label?: string | undefined;
    isInvalid?: boolean | undefined;
    errorMsg?: string;
    options?: {value: any, label: string}[] | undefined;
    isSearchable?: boolean | undefined;
    isTextIcon?: boolean;
  }

// Note : Because i have no idea, please if using this, your place holder must be like this example
// Choose Route, Choose Client, Choose Vending
// and it will take the last word of it with ':' , ex. Route: , Client: , Vending:
const ControlTextIcon = ({ children, ...rest }: any) => {
  const { placeholder } = rest.selectProps;
  return (
  // eslint-disable-next-line react/jsx-props-no-spreading
    <components.Control {...rest}>
      <div style={{ marginLeft: '8px', marginRight: '-2px' }}>
        <div className="color-placeholder fz-14">{`${placeholder.split(' ')[1]}:`}</div>
      </div>
      {children}
    </components.Control>
  );
};

export const ControlSearchIcon = ({ children, ...rest }: any) => {
  const { isSearchable } = rest.selectProps;
  return (
  // eslint-disable-next-line react/jsx-props-no-spreading
    <components.Control {...rest}>
      <div style={isSearchable ? { marginLeft: '8px', marginRight: '-2px' } : { display: 'none' }}>
        <SearchSmall />
      </div>
      {children}
    </components.Control>
  );
};

const Default:React.FC<Props> = (props) => {
  const {
    value, placeholder, disabled, onChange,
    label, className, isInvalid, errorMsg,
    id, onBlur, options, isSearchable = true,
    isTextIcon,
  } = props;
  const { customStyle } = useReactSelect(isInvalid ?? false);

  return (
    <div className={`d-flex flex-column w-100 position-relative ${className}`}>
      <label htmlFor={id} className={label ? 'label' : 'd-none'}>{label}</label>
      <Select
        options={options}
        styles={customStyle}
        placeholder={placeholder}
        value={value}
        onBlur={onBlur}
        onChange={onChange}
        isDisabled={disabled}
        isSearchable={isSearchable}
        components={{
          IndicatorSeparator: () => null,
          Control: isTextIcon ? ControlTextIcon : ControlSearchIcon,
        }}
      />
      <div
        className={isInvalid ? 'invalidMsg' : 'd-none'}
      >
        {errorMsg}
      </div>
    </div>
  );
};

export default Default;
